import React from "react";
import { Badge, Tooltip } from "@shopify/polaris";

const STATUS_BADGE = {
  completed:  "success",
  processing: "attention",
  failed:     "critical",
  pending:    "new",
};

const STATUS_LABEL = {
  completed:  "Done",
  processing: "Running",
  failed:     "Failed",
  pending:    "Pending",
};

export default function LetterProgressGrid({ letters, letterProgress }) {
  if (!letterProgress) return null;

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "8px" }}>
      {letters.map((letter) => {
        const info   = letterProgress[letter] || {};
        const status = info.status || "pending";

        const tooltip = status === "pending"
          ? "Waiting to start"
          : [
              `Scraped: ${info.rows_scraped ?? 0}`,
              `New: ${info.inserted ?? 0}`,
              `Updated: ${info.updated ?? 0}`,
              `Errors: ${info.errors ?? 0}`,
            ].join(" · ");

        return (
          <Tooltip key={letter} content={tooltip}>
            <div
              style={{
                padding:      "8px 4px",
                borderRadius: "6px",
                textAlign:    "center",
                background:   "#f6f6f7",
                cursor:       "default",
              }}
            >
              <div style={{ fontWeight: 600, fontSize: "13px", marginBottom: "4px" }}>
                {letter}
              </div>
              <Badge status={STATUS_BADGE[status]}>{STATUS_LABEL[status]}</Badge>
              {status !== "pending" && (
                <div style={{ fontSize: "11px", color: "#6d7175", marginTop: "4px" }}>
                  {info.rows_scraped ?? 0} rows
                </div>
              )}
            </div>
          </Tooltip>
        );
      })}
    </div>
  );
}
